import React, { useState, useEffect } from 'react';
import {  useParams } from 'react-router-dom';
import "../assete/css/careersdetails.css";
import Header from './Header';
import career_pic_new from "../assete/image/c3.jpg";
import { ViewCareerDetailsSingleApi} from "../service/Api";
import Footer from './Footer';

const Careersdetails = () => {
  const { id } = useParams(); 
  const [details, setDetails] = useState([]);

   useEffect(() => {
             const fetchData = async () => {
                 try {
                     const response = await ViewCareerDetailsSingleApi(`${id}`);
                     if (response && response.careersdetails) {
                         setDetails(response.careersdetails.reverse());
                     }
                 } catch (error) {
                     console.error('Error fetching data:', error);
                 }
             };
             fetchData();
         }, [id]);
  
  return (
   <>
   <Header/>
   <div className='seasense_web_career_main'>
    <img src={career_pic_new} alt=""/>
   
  
        <div className="about_content" >      
  
    </div>
         </div>

         {details.length > 0 ? (
        details.map((detail, index) => (
          <div className='careers_datails_view' key={index}>
            <div className='careers_datails_view_1'>
              <h1>{detail.job_name} </h1>
              <h2><label>Job Name</label>: {detail.job_name}</h2>
              <h2><label>Education/Qualification</label>: {detail.Education}</h2>
              <h2><label>Experience</label>: {detail.Experience}</h2>
              <h2><label>Job Location</label>: {detail.Location}</h2>
              <h2><label>Job opening date</label>: {detail.Job_date}</h2>
              <h2><label>Job Description</label>: {detail.Job_Description}</h2>
              <div className='apply_div_btn'>
<button onClick={() => window.open('https://career.seasensegroup.com?clg=qBf5d1r8O73juaZc9ebx', '_blank')}>
  Apply Now
  <svg fill="currentColor" viewBox="0 0 24 24" className="icon">
    <path
      clipRule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
      fillRule="evenodd"
    />
  </svg>
</button>

  
</div>

            </div>
          </div>
        ))
      ) : (
        <div className="no_data_message">
          <h3>No career details available</h3>
        </div>
      )}
      <Footer/>
    </>
  );
};
export default Careersdetails